import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import authenticationStorage from '@/store/modules/authentication-storage';
import resetPasswordStorage from '@/store/modules/reset-password-storage';
import signupStorage from '@/store/modules/signup-storage';
import profileStorage from '@/store/modules/profile-storage';
import eventStorage from '@/store/modules/event-storage';
import eventFlowStorage from '@/store/modules/event-flow-storage';
import customerProjectStorage from '@/store/modules/customer-project-storage';
import locationsStorage from '@/store/modules/locations-storage';
import adminStorage from '@/store/modules/admin-storage';
import responsibleStorage from '@/store/modules/responsible-storage';
import topicsStorage from '@/store/modules/topics-storage';
import sheetStorage from '@/store/modules/sheet-storage';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['authenticationStorage'],
});

export default new Vuex.Store({
    modules: {
        authenticationStorage,
        resetPasswordStorage,
        signupStorage,
        customerProjectStorage,
        profileStorage,
        eventStorage,
        eventFlowStorage,
        locationsStorage,
        topicsStorage,
        adminStorage,
        responsibleStorage,
        sheetStorage,
    },
    plugins: [vuexLocal.plugin],
});
